import React, { forwardRef, useImperativeHandle, useRef, useEffect } from "react";

const ALLOWED_KEYS = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Home', 'End'];

const DoubleEditor = forwardRef((props, ref) => {
    const inputRef = useRef(null);
    const allowDash = props.allowDash ?? false;

    useEffect(() => {
        setTimeout(() => {
            if (!inputRef.current) return;
            inputRef.current.focus();
            inputRef.current.select();
        });
    }, []);

    useImperativeHandle(ref, () => ({
        getValue() {
            return inputRef.current?.value ?? '';
        }
    }));

    const onKeyDown = (e) => {
        if (ALLOWED_KEYS.includes(e.key)) return;
        if (e.ctrlKey || e.metaKey) return;
        if (/^[0-9.]$/.test(e.key)) return;
        if (allowDash && e.key === '-' && inputRef.current?.value === '') return;
        e.preventDefault();
    };

    const initialValue = props.charPress != null
        ? (/^[0-9.]$/.test(props.charPress) ? props.charPress : '')
        : (props.value ?? '');

    return (
        <input
            ref={inputRef}
            defaultValue={initialValue}
            onKeyDown={onKeyDown}
            style={{ width: '100%', height: '100%', border: 'none', outline: 'none', padding: '0 4px' }}
        />
    );
});

export default DoubleEditor;
